import React from 'react';

import { TextSMContainer } from './styles';
import { TextMDContainer } from './styles';
import { TextLGContainer } from './styles';
import { TextXLContainer } from './styles';

export type TextProps = React.ComponentPropsWithoutRef<'p'> & {
  children: React.ReactNode;

  weight?: 'regular' | 'medium' | 'semibold' | 'bold';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  textColor?: 'light' | 'dark';
};

export const Text: React.FC<TextProps> = ({
  children,
  weight = 'regular',
  size = 'lg',
  textColor = 'dark',

  ...props
}) => {
  switch (size) {
    case 'sm':
      return (
        <TextSMContainer textColor={textColor} weight={weight} {...props}>
          {children}
        </TextSMContainer>
      );
    case 'md':
      return (
        <TextMDContainer textColor={textColor} weight={weight} {...props}>
          {children}
        </TextMDContainer>
      );
    case 'lg':
      return (
        <TextLGContainer textColor={textColor} weight={weight} {...props}>
          {children}
        </TextLGContainer>
      );
    case 'xl':
      return (
        <TextXLContainer textColor={textColor} weight={weight} {...props}>
          {children}
        </TextXLContainer>
      );

    default:
      return (
        <TextMDContainer textColor={textColor} weight={weight} {...props}>
          {children}
        </TextMDContainer>
      );
  }
};

export default Text;
